import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { PaymentScenarionConditionKindEnum } from '@zaoblako/shared/modules/task/enum/payment.scenarion.condition.kind.enum';
import { PaymentScenarionConditionTypeEnum } from '@zaoblako/shared/modules/task/enum/payment.scenarion.condition.type.enum';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { PaymentTaskScenarioConditionTypeNamePipe } from '@zaoblako/web/shared/pipes/payment-task-scenario-condition-type-name.pipe';

@Component({
  selector: 'crm-payment-task-scenario-condition-type-single-select',
  standalone: true,
  imports: [CommonModule, SingleSelectComponent, PaymentTaskScenarioConditionTypeNamePipe],
  templateUrl: './payment-task-scenario-condition-type-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentTaskScenarioConditionTypeSingleSelectComponent implements OnChanges {
  @Input() public type: PaymentScenarionConditionTypeEnum;
  @Input() public kind: PaymentScenarionConditionKindEnum;

  @Input() public styleClass: string;
  @Input() public class: string;
  @Input() public appendTo: any;

  @Output() public typeChange: EventEmitter<PaymentScenarionConditionTypeEnum> =
    new EventEmitter<PaymentScenarionConditionTypeEnum>();

  public options: PaymentScenarionConditionTypeEnum[] = [
    PaymentScenarionConditionTypeEnum.BIGGER_THAN,
    PaymentScenarionConditionTypeEnum.EQUAL,
    PaymentScenarionConditionTypeEnum.LOWER_THAN
  ];

  public constructor(private readonly cdRef: ChangeDetectorRef) {}

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.kind?.currentValue) {
      switch (this.kind) {
        case PaymentScenarionConditionKindEnum.DIRECTION:
        case PaymentScenarionConditionKindEnum.UNIT:
        case PaymentScenarionConditionKindEnum.FILIAL:
        case PaymentScenarionConditionKindEnum.COMPANY:
        case PaymentScenarionConditionKindEnum.DEAL:
        case PaymentScenarionConditionKindEnum.COST_CENTER: {
          this.options = [PaymentScenarionConditionTypeEnum.EQUAL];
          break;
        }
        case PaymentScenarionConditionKindEnum.AMOUNT:
        case PaymentScenarionConditionKindEnum.BUDGET_EXHAUSTED: {
          this.options = [
            PaymentScenarionConditionTypeEnum.BIGGER_THAN,
            PaymentScenarionConditionTypeEnum.EQUAL,
            PaymentScenarionConditionTypeEnum.LOWER_THAN
          ];
          break;
        }
        case PaymentScenarionConditionKindEnum.EXCEEDING_PLAN: {
          this.options = [PaymentScenarionConditionTypeEnum.NONE];
          break;
        }
        default: {
          this.options = Object.values(PaymentScenarionConditionTypeEnum);
          break;
        }
      }
      setTimeout(() => {
        this.type = this.options[0];
        this.cdRef.markForCheck();
        this.typeChange.emit(this.type);
      }, 0);
    }
  }
}
